import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router';
import styles from './PostRelatedItem.css';

class PostRelatedItem extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
  };

  render() {
    const { post } = this.props;

    return (
      <Link to={`/journal/${post.title}`}>
        <div className={styles.listImg}>
          {post.listImg && (
            <div className={styles.content} style={{ backgroundImage: `url(${post.listImg.url})` }} />
          )}
          {!post.listImg && (
            <div className={classnames(styles.content, styles.placeholder)} />
          )}
        </div>
        <p className={styles.postTitle}>{post.title}</p>
      </Link>
    );
  }
}

export default PostRelatedItem;



// WEBPACK FOOTER //
// ./src/components/post-related-item/PostRelatedItem.js